const notImplemented = (methodName) => {
  return Promise.reject(`${methodName} is not implemented`);
};

class BaseBreakoutRoomsProvider {
  async getConfiguration() {
    return notImplemented("getConfiguration");
  }
  async getLanguages() {
    return notImplemented("getLanguages");
  }
  async sendInvite() {
    return notImplemented("sendInvite");
  }
  async getInviteStatus(requestId) {
    return notImplemented("getInviteStatus ");
  }
  async cancelInviteRequest(requestId) {
    return notImplemented("getRoomData");
  }
}

export default BaseBreakoutRoomsProvider;
